import { render, staticRenderFns } from "./Publicity.vue?vue&type=template&id=0aec477f&"
import script from "./Publicity.vue?vue&type=script&lang=js&"
export * from "./Publicity.vue?vue&type=script&lang=js&"
import style0 from "./Publicity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports